<template>
  <div class="google-map">
    <div class="mapouter">
      <div class="gmap_canvas">
        <iframe width="100%" height="100%" id="gmap_canvas" :src="`https://maps.google.com/maps?q=${street}, Maringá PR, Brazil&t=&z=16&ie=UTF8&iwloc=&output=embed`" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
        <a href="https://www.embedgooglemap.net/blog/nordvpn-coupon-code/"></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'google-map',
  props: ['street'],
};
</script>

<style scoped>
.google-map {
  position: relative;
  height: 400px;
  width: 100%;
}
.mapouter {
  position: absolute;
  height: 100%;
  width: 100%;
}
.gmap_canvas {
  height: 100%;
  width: 100%;
}
</style>
